import { Analytics } from './analytics';
import { AddCartModalAction } from '../add_cart/modal_action';

export class AddCartAnalytics extends Analytics {
  constructor() {
    super();
    AddCartModalAction.CART_SUBMIT_EVENT.on((data) => {
      this.run(() => {
        const item = data.analyticsData.items[0];
        const productName = item.getProductName();
        const medicalMaterialType = item.getMedicalMaterialType();
        const linkAnalyticsData = {
          events: ['scAdd'],
          server: 'club/pc',
          fName: 'かご投入完了',
          items: [this.items(productName, medicalMaterialType)],
          club: {
            events: ['scAdd'],
            server: 'club/pc',
            prop5: 'かご投入完了',
            products: [this.products(item._catalogItemCode, medicalMaterialType)]
          },
          soloel: {
            events: ['scAdd'],
            server: 'soloel/pc',
            prop5: 'カート投入完了',
            products: [this.products(item.getProductNameForSoloel(), medicalMaterialType)]
          }
        };

        // Criteo広告でカゴ入れの際に必要な情報を設定
        const internalCampaignCode = item.getInternalCampaignCode();
        if (internalCampaignCode !== undefined) {
          linkAnalyticsData['internalCampaignCode'] = internalCampaignCode;
          linkAnalyticsData.club['prop20'] = internalCampaignCode;
        }

        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });

    AddCartModalAction.POSITIVE_TRANSITIONS_EVENT.on((data) => {
      this.run(() => {
        const item = data.analyticsData.items[0];
        const productName = item.getProductName();
        const medicalMaterialType = item.getMedicalMaterialType();
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'かご投入完了',
          events: ['scAdd', 'event211', 'event212'],
          items: [this.items(productName, medicalMaterialType)],
          club: {
            server: 'club/pc',
            prop5: 'かご投入完了',
            events: ['scAdd', 'event211', 'event212'],
            products: [this.products(item._catalogItemCode, medicalMaterialType)]
          }
        };

        // Criteo広告でカゴ入れの際に必要な情報を設定
        const internalCampaignCode = item.getInternalCampaignCode();
        if (internalCampaignCode !== undefined) {
          linkAnalyticsData['internalCampaignCode'] = internalCampaignCode;
          linkAnalyticsData.club['prop20'] = internalCampaignCode;
        }
        
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }

  private items(productName: string, evars: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: this.medicalMaterialType(evars)
    };
  }

  private products(productName: string, evars: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: this.eVar79(evars)
    };
  }

  private medicalMaterialType(evars: string) {
    return { medicalMaterialType: evars };
  }

  private eVar79(evars: string) {
    return { eVar79: evars };
  }
}
